
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/incentives-and-policy",
      function () {
        return require("private-next-pages/incentives-and-policy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/incentives-and-policy"])
      });
    }
  